import * as c from './constants';


export function tyroPair(mid, tid, callback) {
  return { type: c.TYRO_PAIR_TERMINAL, payload: { mid, tid, callback } };
}


export function tyroCancelTransaction() {
  return { type: c.TYRO_CANCEL_TRANSACTION };
}


export function tyroResetModal() {
  return { type: c.TYRO_RESET_MODAL };
}


export function tyroShowModal() {
  return { type: c.TYRO_SET_MODAL_STATUS, payload: true };
}


export function tyroHideModal() {
  return { type: c.TYRO_SET_MODAL_STATUS, payload: false };
}


export function tyroResetStatus() {
  return { type: c.TYRO_RESET_STATUS };
}


export function tyroSetMessageStatus(message) {
  return { type: c.TYRO_SET_MESSAGE_STATUS, payload: message };
}


export function tyroSetErrorStatus(message) {
  return { type: c.TYRO_SET_ERROR_STATUS, payload: message };
}


export function tyroSetQuestionStatus(message, options) {
  return { type: c.TYRO_SET_QUESTION_STATUS, payload: { message, options } };
}


export function tyroSetQuestionAnswer(answer) {
  return { type: c.TYRO_SET_QUESTION_ANSER, payload: answer };
}